module.exports = __webpack_public_path__ + "static/article-ef6a4f846255cc799621b441bd331c4c.jpg";